import React, { useState, useEffect, useContext } from "react";
import { useParams, useHistory } from "react-router";
import { Button, TextField, Typography } from "@mui/material";
import moment from "moment";

import CreatableSelect from "react-select/creatable";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Swal from "sweetalert2";
import Toast from "../../utils/Toast";

import { AuthContext } from "../../utils/userProvider";

import useProperty from "../../queries/property/getProperties";
import useRateNumber from "../../queries/rateNumber/getRateNumber";
import useCreateAudit from "../../mutation/audit/createAudit";
import {
  FormPageShell,
  FormPageCard,
  FormPageHeader,
  FormActions,
} from "../../components/ListPage";

const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  code: yup.string().required("Promo Code is required"),
  startDate: yup.date().required("Start Date is required"),
  endDate: yup.date().required("End Date is required"),
  prop: yup.object().required("A property must be selected."),
});

const EditRateNumber = (props) => {
  const { id } = useParams();
  const history = useHistory();
  const [response, resetRateNumber] = useRateNumber(id);
  const [propertyResponse, setPropertiesResponse] = useProperty();
  const { authState, setAuthState } = useContext(AuthContext);

  const [auditResponse, setAuditData] = useCreateAudit();
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());

  const [propertyOptions, setPropertyOptions] = useState([]);
  const [defaultPropertyValue, setDefaultPropertyValue] = useState();
  const [currentData, setCurrentData] = useState();
  const [snapshotCurrent, setSnapshotCurrent] = useState({});

  const propertyChange = (value) => {
    setValue("prop", value);
  };

  const { control, register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  useEffect(() => {
    if (response.data) {
      setSnapshotCurrent(response.data);
      setCurrentData(response.data.id);
      setValue("name", response.data.name);
      setValue("code", response.data.code);
      setValue("startDate", response.data.startDate);
      setStartDate(moment(response.data.startDate));
      setValue("endDate", response.data.endDate);
      setEndDate(moment(response.data.endDate));
      let propObj = {
        label: response.data.prop.name,
        value: response.data.prop.id,
      };
      setValue("prop", propObj);
      setDefaultPropertyValue(propObj);
    }
    if (propertyResponse.data) {
      //setup options
      let data = propertyResponse.data;
      let propertyOptions = [];
      for (var i = 0; i < data.length; i++) {
        let property = data[i];
        propertyOptions.push({
          label: property.name,
          value: property.id,
        });
      }

      setPropertyOptions(propertyOptions);
    }
  }, [response, propertyResponse]);

  const goBack = () => {
    window.location.href = "/dashboard/rate-numbers";
  };

  const handleStartDateChange = (value) => {
    setStartDate(value);
    setValue("startDate", value.toDate());
  };
  const handleEndDateChange = (value) => {
    setEndDate(value);
    setValue("endDate", value.toDate());
  };

  const onSubmit = (values) => {
    console.log(values);
    values.startDate = moment(values.startDate).endOf("day");
    values.endDate = moment(values.endDate).endOf("day");
    values.prop = values.prop.value;

    Swal.fire({
      title: "Create Updates",
      html: `<h4>Please provide a description before submitting your changes</h4>
            <textarea maxlength="100" type="text" id="actionDescription" class="swal2-input" placeholder="Description" font-size=18px style="height:auto!important" rows=5>`,
      confirmButtonText: "Confirm",
      focusConfirm: false,
      preConfirm: () => {
        const actionDescription =
          Swal.getPopup().querySelector("#actionDescription").value;
        if (!actionDescription) {
          Swal.showValidationMessage(`Please enter description`);
        }
        return {
          actionDescription: actionDescription,
          newData: values,
          snapshotCurrent: snapshotCurrent,
          currentData: currentData,
          type: "rate-number",
          action: "update",
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setAuditData(result.value);
      }
    });
  };

  useEffect(() => {
    try {
      if (auditResponse.data) {
        Toast.fire({
          icon: "success",
          title: "Rate Number update Audit Created",
        });
        history.push("/dashboard/rate-numbers");
      } else if (auditResponse.error) {
        let data = auditResponse.errorMessage.response.data;
        if (data) {
          let messageData = data.message;
          let message = messageData.message;

          if (message == "Dates Unavailable") {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "The time period for the Rate number overlaps with an existing rate number. Please change the time period.",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: message,
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: auditResponse.error.message,
          });
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  }, [auditResponse]);

  const renderContent = () => {
    return (
      <FormPageShell>
        <form noValidate onSubmit={handleSubmit(onSubmit)}>
          <FormPageCard>
            <FormPageHeader
              title={
                authState.editAccess
                  ? "Edit Rate Number"
                  : "View Rate Number"
              }
              onBack={goBack}
              subtitle={
                authState.editAccess
                  ? "Please fill in the required fields."
                  : undefined
              }
            />
            <TextField
              name="name"
              margin="normal"
              fullWidth
              label="Name*"
              variant="outlined"
              inputRef={register}
              error={errors.name != null}
              helperText={errors.name != null ? errors.name.message : null}
              disabled={auditResponse.loading || !authState.editAccess}
            />
            <TextField
              name="code"
              margin="normal"
              fullWidth
              label="Code*"
              variant="outlined"
              inputRef={register}
              error={errors.code != null}
              helperText={errors.code != null ? errors.code.message : null}
              disabled={auditResponse.loading || !authState.editAccess}
            />
            <Controller
              name="startDate"
              control={control}
              defaultValue={startDate}
              render={({ ...props }) => {
                return (
                  <DatePicker
                    label="Start Date*"
                    value={startDate}
                    onChange={handleStartDateChange}
                    format="DD/MM/YYYY"
                    maxDate={endDate}
                    disabled={
                      auditResponse.loading || !authState.editAccess
                    }
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        fullWidth: true,
                        margin: "normal",
                        error: errors.startDate != null,
                        helperText:
                          errors.startDate != null
                            ? errors.startDate.message
                            : null,
                      },
                    }}
                  />
                );
              }}
            />
            <Controller
              name="endDate"
              control={control}
              defaultValue={endDate}
              render={({ ...props }) => {
                return (
                  <DatePicker
                    label="End Date*"
                    value={endDate}
                    onChange={handleEndDateChange}
                    format="DD/MM/YYYY"
                    minDate={startDate}
                    disabled={
                      auditResponse.loading || !authState.editAccess
                    }
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        fullWidth: true,
                        margin: "normal",
                        error: errors.endDate != null,
                        helperText:
                          errors.endDate != null
                            ? errors.endDate.message
                            : null,
                      },
                    }}
                  />
                );
              }}
            />
            {propertyOptions.length > 0 && (
              <div>
                <Typography sx={{ fontSize: 16, fontWeight: "bold", mt: 1 }}>
                  Property
                </Typography>
                <div>
                  <Controller
                    name="prop"
                    control={control}
                    defaultValue={
                      defaultPropertyValue ? defaultPropertyValue : null
                    }
                    render={({ ...props }) => {
                      return (
                        <CreatableSelect
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              borderColor: errors.room_types
                                ? "red"
                                : provided.borderColor,
                            }),
                          }}
                          defaultValue={
                            defaultPropertyValue
                              ? defaultPropertyValue
                              : null
                          }
                          options={propertyOptions}
                          onChange={propertyChange}
                          isDisabled={
                            auditResponse.loading || !authState.editAccess
                          }
                        />
                      );
                    }}
                  />
                  {errors.properties && (
                    <div>{errors.properties.message}</div>
                  )}
                </div>
              </div>
            )}
          </FormPageCard>
          {authState.editAccess && (
            <FormPageCard sx={{ mt: 2 }}>
              <FormActions>
                <Button
                  type="submit"
                  size="large"
                  variant="contained"
                  color="primary"
                  disabled={auditResponse.loading}
                >
                  Submit
                </Button>
              </FormActions>
            </FormPageCard>
          )}
        </form>
      </FormPageShell>
    );
  };

  return !response.loading && !propertyResponse.loading && renderContent();
};

export default EditRateNumber;
